import { GET_SURVEY_TIMINGS, GET_PUBLIC_SURVEY_TIMINGS } from '../../fetchTypes';
import {
  createDefaultRequestInitialState,
  createSelectorById,
  createSelectorByIdList,
  defaultRequestByIdReducer,
} from './withFetch';
const baseInitialState = {};
const initialState = createDefaultRequestInitialState();
export const actionDataToId = (data) => data.projectId;

const reducer = defaultRequestByIdReducer({
  actionDataToId,
  resultMapper: (data) => {
    try {
      let result = null;
      let headers = [];
      const { response } = data || {};
      if (!response || !response.length) {
        // response is empty array when the survey isn't live or savetimings is false
        return { timingsById: {}, headers: [] };
      }
      result = atob(response); //.replace(/\\"/g, '"');
      headers =
        ((result || '').split(/\s*(?:{|})\s*/g)[3] || '').match(
          /"[^"]+"\s*:/g
        ) || [];
      headers = headers.map((header) => header.split(/"/g).filter((x) => x)[0]);
      // calculate header keys from the original json text to make sure they are correctly ordered
      result = (JSON.parse(result) || {}).responses || [];
      result = result.reduce(
        (acc, submission) => ({ ...acc, ...submission }),
        {}
      );
      return { timingsById: result, headers };
    } catch (e) {
      console.error(e);
      return { timingsById: {}, headers: [] };
    }
  },
  baseInitialState,
  extraOnSuccess: (state, projectId) => {
    const nextState = { ...state };
    // const nextState = { ...state, questionByQid: { ...state.questionByQid } };

    return nextState;
  },
});

export default (state = initialState, action) => {
  switch (action.fetchType) {
    case GET_SURVEY_TIMINGS:
      return reducer(state, action);
    case GET_PUBLIC_SURVEY_TIMINGS:
      return reducer(state, action);
    default:
      return state;
  }
};

const selfSelector = (state) => state.fetcher.surveyTimings;
export const selectFetcherSurveyTimings = selfSelector;
export const selectSurveyTimingsByProjectId = createSelectorById(selfSelector);
export const selectSurveyTimingsListByProjectIdList =
  createSelectorByIdList(selfSelector);
